import * as requests from "../../coraWebComponents/utils/requests";
import { strToDate } from '../../coraWebComponents/utils/convert';
import urls from "../../constants/Urls";

const buildOM = (id = "") => {
  return `${urls.OdberneMiesto}/${id}`;
};

export const getOM = async (id) => {
  if (id === 0) return null;

  const url = buildOM(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListOM = async (filter, sort, page) => {
  const url = buildOM();

  try {
    let res = await requests.getList(url, filter, sort, page);
    res.Data.Items.forEach((item) => {
        item.D_ZAC = strToDate(item.D_ZAC);
    });
    return res;
  } catch (error) {
    throw error;
  }
};
